export default {
    quickForm: {
        background: "#FFF",
        padding: "15px"
    },
    icwlogo: {
        width: "121px",
        cursor: "pointer"
    },
    pageTitle: {
        fontSize: "24px",
        fontWeight: "bold"
    },
    box: {
        padding: "15px"
    },
    boxTitle: {
        fontSize: "16px",
        fontWeight: 600
    },
    boxContent: {
        fontSize: "14px",
        color: "#263238"
    },
    title: {
        fontSize: "16px",
        fontWeight: "bold"
    },
    subTitle: {
        fontSize: "12px",
        color: "rgba(0, 0, 0, 0.54)"
    },
    iconButton: {
        width: "auto",
        height: "auto",
        opacity: "0.5",
    },
    dialogTitle: {
        paddingBottom: 0
    },
    dialogCloseButton: {
        position: "absolute",
        top: 0,
        right: 0
    },
    dialogContent: {
        paddingBottom: 0
    },
    dialogSignUpButton: {
        margin: "20px 0 10px"
    },
    dialogLoginButton: {
        margin: "20px 0"
    },
    dialogReminder: {
        fontSize: "10px",
        color: "rgba(0, 0, 0, 0.54)",
        paddingBottom: "20px"
    },
    dialogActions: {
        textAlign: "left",
        margin: 0,
        padding: "10px 20px 20px",
        justifyContent: "normal",
        "& *": {
            fontSize: "12px"
        }
    }
};
